import { type CountryCode } from "@/config/country-config";
import { EmploymentType, IncomeType, Period } from "@/types/form";

export const getMockApplicantContact = (country: CountryCode) => {
	if (country === "FI") {
		return {
			firstName: "Matti",
			lastName: "Perkele",
			nationalId: "070881-021J",
			mobileCountry: "FI" as const,
			mobileNumber: "0401234567",
			emailAddress: "matti@perkele.fi",
		} as const;
	}

	return {
		firstName: "Gunnar",
		lastName: "Gunnarson",
		nationalId: "202310052390",
		mobileCountry: "SE" as const,
		mobileNumber: "0712302300",
		emailAddress: "gunnarson@gunnarson.com",
	} as const;
};

export const getMockCoApplicantContact = (country: CountryCode) => {
	const base = getMockApplicantContact(country);

	if (country === "SE") {
		return {
			...base,
			nationalId: "202310052317",
			mobileNumber: "0709876543",
			emailAddress: "co-applicant@gunnarson.com",
		};
	}

	return {
		...base,
		nationalId: "131052-308T",
		mobileNumber: "0409876543",
		emailAddress: "co-applicant@perkele.fi",
	};
};

export const getMockEmploymentDefaults = (country: CountryCode) => ({
	employment: {
		type: EmploymentType.PermanentEmployment,
		employer: "Lea Bank",
		startDate: new Date("2021-02-01"),
		numberOfCars: 0,
	},
	income: {
		amount: country === "FI" ? 3_400 : 34_000,
		type: IncomeType.GrossIncome,
		period: Period.Monthly,
	},
});